<template>
    <div id="clubMemberErrors">
        <table class="kgr-table kgr-table--striped table-groups kgr-row">
            <thead>
                <tr class="kgr-table_row">
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ tMembershipNumber }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ tFirstName }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ tLastName }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ tErrorMessage }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="error in errorList"
                    :key="error.entity.id"
                    class="kgr-table_row"
                >
                    <td class="kgr-table__cell">
                        {{ error.entity.membershipNumber }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ error.entity.firstName }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ error.entity.lastName }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ error.errorMessage }}
                    </td>
                    <td class="kgr-table__cell">
                        <a
                            :href="showMember(error.entity.id)"
                            target="_blank"
                        >{{ tShowMember }}</a>
                    </td>
                </tr>
            </tbody>
        </table>
        <button
            v-if="hasMoreErrors"
            class="kgr-button kgr-button--secondary"
            @click="showMore"
        >
            {{ tShowMore }}
        </button>
    </div>
</template>

<script>

export default {
    components: {
    },
    props: {
        errors: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            numberOfResults: 10
        };
    },
    computed: {
        errorList() {
            return this.errors.slice(0, this.numberOfResults);
        },
        hasMoreErrors() {
            return this.errors.length > this.errorList.length;
        },
        tMembershipNumber() {
            return this.$t('member.membershipNumber');
        },
        tFirstName() {
            return this.$t('member.firstName');
        },
        tLastName() {
            return this.$t('member.lastName');
        },
        tErrorMessage() {
            return this.$t('Lists.actions.errors.errorMessage');
        },
        tShowMember() {
            return this.$t('Lists.actions.errors.showMember');
        },
        tShowMore() {
            return this.$t('Lists.actions.errors.showMore');
        }
    },
    methods: {
        showMember(id) {
            return '/backend/clubs/members/' + id + '/show'
        },
        showMore() {
            this.numberOfResults += 10;
        }
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  #clubMemberErrors {
      max-height: 450px;
      overflow-y: auto;
    }
</style>
